import { render, staticRenderFns } from "./NodeServerMonitoring.vue?vue&type=template&id=2c5fdf56&scoped=true&"
import script from "./NodeServerMonitoring.vue?vue&type=script&lang=js&"
export * from "./NodeServerMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./NodeServerMonitoring.vue?vue&type=style&index=0&id=2c5fdf56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5fdf56",
  null
  
)

export default component.exports